module.exports = __webpack_public_path__ + "img/silder.290633ee.jpg";